/* 🤖 this file was generated by svg-to-ts */
export const matIconMultipleStop: {
  name: 'multiple-stop';
  data: string;
} = {
  name: 'multiple-stop',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m17 4 4 4-4 4V9h-4V7h4V4zm-7 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM6 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm1 10h4v-2H7v-3l-4 4 4 4v-3zm7 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/></svg>`
};
